import React, { useState } from "react";
import { FaEnvelope, FaTimes } from "react-icons/fa";
import axios from "axios";
import { usePrezentacija } from "../context/PrezentacijaContext";
import ErrorModal from "./ErrorModal";
import "./PrezentacijaModal.css";

function PrezentacijaModal() {
  const { isOpen, closeModal } = usePrezentacija();

  const API_URL = process.env.REACT_APP_API_URL;

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [mesto, setMesto] = useState("");
  const [message, setMessage] = useState("");
  const [botCheck, setBotCheck] = useState("");
  const [consent, setConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorTitle, setErrorTitle] = useState("Greška");

  const resetForm = () => {
    setFullName("");
    setEmail("");
    setPhone("");
    setCompanyName("");
    setMesto("");
    setMessage("");
    setBotCheck("");
    setConsent(false);
    setFieldErrors({});
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!fullName.trim()) {
      errors.fullName = "Ime i prezime su obavezni.";
    }

    if (!companyName.trim()) {
      errors.companyName = "Naziv firme je obavezan.";
    }

    if (!mesto.trim()) {
      errors.mesto = "Mesto je obavezno.";
    }

    if (!email && !phone) {
      errors.contact = "Unesite email adresu ili broj telefona kako bismo mogli da Vas kontaktiramo.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      errors.email = "Unesite važeću email adresu.";
    }


    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setFieldErrors({});

    // Validacija prošla — odmah zatvoriti prezentacijski modal
    resetForm();
    closeModal();
    setIsSubmitting(true);

    const formData = {
      UserFullName: fullName,
      UserEmail: email,
      UserPhone: phone,
      CompanyName: companyName,
      CompanyLocation: mesto,
      Message: message,
      BotCheck: botCheck,
    };

    try {
      const response = await axios.post(
        `${API_URL}/Login/Korisnik/PosaljiKontaktEmail`,
        formData
      );

      if (response.status === 200) {
        const successMsg =
          response.data?.Message ||
          (typeof response.data === "string" ? response.data : null) ||
          "Vaš zahtev je uspešno poslat! Kontaktiraćemo Vas ubrzo.";
        setErrorMessage(successMsg);
        setErrorTitle("Obaveštenje");
        setShowErrorModal(true);
      }
    } catch (error) {
      const msg =
        error.response?.data?.Message ||
        error.response?.data ||
        "Greška u komunikaciji sa serverom. Proverite internet konekciju i pokušajte ponovo.";
      setErrorMessage(msg);
      setErrorTitle("Greška");
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen && !showErrorModal) return null;

  return (
    <>
      {isOpen && (
        <div className="prez-overlay" onClick={handleOverlayClick}>
          <div className="prez-modal">
            <div className="prez-header">
              <h2>Zakažite besplatan demo</h2>
              <button className="prez-close" onClick={handleClose} aria-label="Zatvori">
                <FaTimes />
              </button>
            </div>

            <div className="prez-body">
              <p className="prez-subtitle">
                Ostavite Vaše podatke i kontaktiraćemo Vas za kratku prezentaciju.
              </p>

              <form onSubmit={handleSubmit} className="prez-form">
                {/* Honeypot */}
                <div style={{ display: "none" }}>
                  <input
                    type="text"
                    name="bot-check"
                    value={botCheck}
                    onChange={(e) => setBotCheck(e.target.value)}
                    tabIndex="-1"
                    autoComplete="off"
                  />
                </div>

                <div className="prez-row">
                  <div className="prez-field">
                    <label htmlFor="prez-fullname">Ime i prezime</label>
                    <input
                      id="prez-fullname"
                      type="text"
                      placeholder="Petar Petrović"
                      value={fullName}
                      className={fieldErrors.fullName ? "prez-input--error" : ""}
                      onChange={(e) => {
                        setFullName(e.target.value);
                        setFieldErrors((prev) => ({ ...prev, fullName: undefined }));
                      }}
                    />
                    {fieldErrors.fullName && (
                      <span className="prez-field-error">{fieldErrors.fullName}</span>
                    )}
                  </div>
                  <div className="prez-field">
                    <label htmlFor="prez-email">Email adresa</label>
                    <input
                      id="prez-email"
                      type="email"
                      placeholder="petar@firma.rs"
                      value={email}
                      className={fieldErrors.email || fieldErrors.contact ? "prez-input--error" : ""}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setFieldErrors((prev) => ({ ...prev, email: undefined, contact: undefined }));
                      }}
                    />
                    {(fieldErrors.email || fieldErrors.contact) && (
                      <span className="prez-field-error">{fieldErrors.email || fieldErrors.contact}</span>
                    )}
                  </div>
                </div>

                <div className="prez-row">
                  <div className="prez-field">
                    <label htmlFor="prez-phone">Broj telefona</label>
                    <input
                      id="prez-phone"
                      type="tel"
                      placeholder="064 123 4567"
                      value={phone}
                      className={fieldErrors.phone || fieldErrors.contact ? "prez-input--error" : ""}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        setFieldErrors((prev) => ({ ...prev, phone: undefined, contact: undefined }));
                      }}
                    />
                    {fieldErrors.phone && (
                      <span className="prez-field-error">{fieldErrors.phone}</span>
                    )}
                  </div>
                  <div className="prez-field">
                    <label htmlFor="prez-company">Naziv firme</label>
                    <input
                      id="prez-company"
                      type="text"
                      placeholder="Firma d.o.o."
                      value={companyName}
                      className={fieldErrors.companyName ? "prez-input--error" : ""}
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        setFieldErrors((prev) => ({ ...prev, companyName: undefined }));
                      }}
                    />
                    {fieldErrors.companyName && (
                      <span className="prez-field-error">{fieldErrors.companyName}</span>
                    )}
                  </div>
                </div>

                <div className="prez-row">
                  <div className="prez-field">
                    <label htmlFor="prez-mesto">Mesto</label>
                    <input
                      id="prez-mesto"
                      type="text"
                      placeholder="Vaše mesto"
                      value={mesto}
                      className={fieldErrors.mesto ? "prez-input--error" : ""}
                      onChange={(e) => {
                        setMesto(e.target.value);
                        setFieldErrors((prev) => ({ ...prev, mesto: undefined }));
                      }}
                    />
                    {fieldErrors.mesto && (
                      <span className="prez-field-error">{fieldErrors.mesto}</span>
                    )}
                  </div>
                  <div className="prez-field prez-field--message">
                    <label htmlFor="prez-message">
                      Poruka <span className="prez-char-count">{message.length}/300</span>
                    </label>
                    <textarea
                      id="prez-message"
                      placeholder="Kratka napomena (opciono)"
                      value={message}
                      onChange={(e) => {
                        if (e.target.value.length <= 300) setMessage(e.target.value);
                      }}
                      maxLength="300"
                    />
                  </div>
                </div>

                <div>
                  <label className="prez-consent">
                    <input
                      type="checkbox"
                      checked={consent}
                      onChange={(e) => {
                        setConsent(e.target.checked);
                        setFieldErrors((prev) => ({ ...prev, consent: undefined }));
                      }}
                    />
                    <span>Slažem se da me kontaktirate u vezi prezentacije</span>
                  </label>
                </div>

                <button
                  type="submit"
                  className="prez-submit"
                  disabled={isSubmitting || !consent}
                >
                  {isSubmitting ? "Slanje..." : "Pošalji zahtev"}
                  {!isSubmitting && <FaEnvelope className="prez-submit-icon" />}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {showErrorModal && (
        <ErrorModal
          message={errorMessage}
          title={errorTitle}
          onClose={() => setShowErrorModal(false)}
        />
      )}
    </>
  );
}

export default PrezentacijaModal;
